<template>
  <h1>sadasd</h1>

</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import store from "@/store";

export default {
  name: "CheckLogin",
  data() {
    return {
      apiUrl: store.getters.baseUrl,
      apiBaseUrl: window.appConfig.API_URL_BASE,
      admin: false,
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }
  },
  methods:{
    setCookie(token) {
      Cookies.set('token', token, {expires: 7, path: '/'});
    },
    getUserInfo(token) {
      let url = this.apiBaseUrl + 'api/users/get-user'
      this.headers['Authorization'] = 'Bearer ' + token
      axios.get(url,
          {headers: this.headers}).then(res => {
        let data = JSON.stringify(res.data)
        localStorage.setItem('userInfo', data)
        this.$store.dispatch('updateUserData', data);
        this.setCookie(token)
        this.$router.push('/')

      }).catch(err =>{
        if (err?.response?.status === 401) {
          this.logout()
        }

      })
    },
    getTokenUrl(){
      const urlParams = new URLSearchParams(window.location.search);
      let token = urlParams.get('token')

      if( token !== undefined && token !== null){
        this.getUserInfo(token)
      }else{
        this.$router.push('/auth/login')
      }
    },
    logout() {
      this.removeCookie()
      this.$router.push('/auth/login')
      store.commit('setMobile', '')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('panelRole')
      localStorage.removeItem('panel-role')


    },
    removeCookie() {
      Cookies.remove('token');
    },
  },
  mounted() {
    this.getTokenUrl()

  }
}
</script>

<style scoped>

</style>
